import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ApprovalRequest from './approval-request-model'
import {
  CreateApprovalRequestAsync,
  DeleteApprovalRequestAsync,
  LoadApprovalRequestsAsync,
} from './approvalRequest-thunk'
const initialState: approvalRequestSliceState = {
  approvalRequest: [],
  selected_approvalRequest: '',
  is_loading_approvalRequest: false,
  is_creating_approvalRequest: false,
  is_deleting_approvalRequest: false,
}
export interface approvalRequestSliceState {
  approvalRequest: ApprovalRequest[]
  selected_approvalRequest?: string
  is_loading_approvalRequest: boolean
  is_creating_approvalRequest: boolean
  is_deleting_approvalRequest: boolean
}
export const approvalRequestSlice = createSlice({
  name: 'approvalRequest',
  initialState,
  reducers: {
    setSelectedapprovalRequest: (state, action) => {
      state.selected_approvalRequest = action.payload
    },
    clearStateapprovalRequest: (state) => {
      state.approvalRequest = []
      state.is_loading_approvalRequest = false
      state.is_creating_approvalRequest = false
      state.is_deleting_approvalRequest = false
    },
    mergeapprovalRequest: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_approvalRequest = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.approvalRequest = merge(state.approvalRequest, payload) as any
        }
      }
    },

    add_approvalRequest: (state, action) => {
      if (action.payload) {
        state.approvalRequest = [...state.approvalRequest, action.payload]
      }
    },
    set_approvalRequest: (state, action) => {
      let { key, value, id } = action.payload
      state.approvalRequest = state.approvalRequest.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadApprovalRequestsAsync.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(LoadApprovalRequestsAsync.fulfilled, (state, action) => {
      state.is_loading_approvalRequest = false
      if (action.payload) {
        state.approvalRequest = action.payload
      }
    })
    builder.addCase(LoadApprovalRequestsAsync.rejected, (state) => {
      state.is_loading_approvalRequest = false
    })
    builder.addCase(CreateApprovalRequestAsync.pending, (state) => {
      state.is_creating_approvalRequest = true
    })
    builder.addCase(CreateApprovalRequestAsync.fulfilled, (state) => {
      state.is_creating_approvalRequest = false
    })
    builder.addCase(CreateApprovalRequestAsync.rejected, (state) => {
      state.is_creating_approvalRequest = false
    })
    builder.addCase(DeleteApprovalRequestAsync.pending, (state) => {
      state.is_deleting_approvalRequest = true
    })
    builder.addCase(DeleteApprovalRequestAsync.fulfilled, (state, action) => {
      state.is_deleting_approvalRequest = false
      if (state.approvalRequest) {
        state.approvalRequest = state.approvalRequest.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteApprovalRequestAsync.rejected, (state) => {
      state.is_deleting_approvalRequest = false
    })

    builder.addCase(
      autoThunks.get_pending_approval_requests.pending,
      (state) => {
        state.is_loading_approvalRequest = true
      },
    )
    builder.addCase(
      autoThunks.get_pending_approval_requests.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_pending_approval_requests.rejected,
      (state) => {
        state.is_loading_approvalRequest = false
      },
    )

    builder.addCase(autoThunks.assign_approval_request.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(
      autoThunks.assign_approval_request.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.assign_approval_request.rejected, (state) => {
      state.is_loading_approvalRequest = false
    })

    builder.addCase(autoThunks.unassign_approval_request.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(
      autoThunks.unassign_approval_request.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.unassign_approval_request.rejected, (state) => {
      state.is_loading_approvalRequest = false
    })

    builder.addCase(autoThunks.get_my_approvals.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(autoThunks.get_my_approvals.fulfilled, (state, action) => {
      state.is_loading_approvalRequest = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.get_my_approvals.rejected, (state) => {
      state.is_loading_approvalRequest = false
    })

    builder.addCase(
      autoThunks.get_processing_approval_requests.pending,
      (state) => {
        state.is_loading_approvalRequest = true
      },
    )
    builder.addCase(
      autoThunks.get_processing_approval_requests.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_processing_approval_requests.rejected,
      (state) => {
        state.is_loading_approvalRequest = false
      },
    )

    builder.addCase(autoThunks.reject_approval_request.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(
      autoThunks.reject_approval_request.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.reject_approval_request.rejected, (state) => {
      state.is_loading_approvalRequest = false
    })

    builder.addCase(autoThunks.approve_approval_request.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(
      autoThunks.approve_approval_request.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.approve_approval_request.rejected, (state) => {
      state.is_loading_approvalRequest = false
    })

    builder.addCase(autoThunks.load_media_approval_request.pending, (state) => {
      state.is_loading_approvalRequest = true
    })
    builder.addCase(
      autoThunks.load_media_approval_request.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_media_approval_request.rejected,
      (state) => {
        state.is_loading_approvalRequest = false
      },
    )

    builder.addCase(
      autoThunks.load_media_approval_requests.pending,
      (state) => {
        state.is_loading_approvalRequest = true
      },
    )
    builder.addCase(
      autoThunks.load_media_approval_requests.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_media_approval_requests.rejected,
      (state) => {
        state.is_loading_approvalRequest = false
      },
    )

    builder.addCase(
      autoThunks.load_series_approval_requests.pending,
      (state) => {
        state.is_loading_approvalRequest = true
      },
    )
    builder.addCase(
      autoThunks.load_series_approval_requests.fulfilled,
      (state, action) => {
        state.is_loading_approvalRequest = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_series_approval_requests.rejected,
      (state) => {
        state.is_loading_approvalRequest = false
      },
    )
  },
})

function handleResult(action: any, state: approvalRequestSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_approvalRequest = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.approvalRequest = merge(state.approvalRequest, payload) as any
    }
  }
}

export const {
  clearStateapprovalRequest,
  setSelectedapprovalRequest,
  set_approvalRequest,
  mergeapprovalRequest,
  add_approvalRequest,
} = approvalRequestSlice.actions

export const get_approvalRequest =
  (id?: string) =>
  (state: {
    approvalRequest: {
      approvalRequest: ApprovalRequest[]
    }
  }): ApprovalRequest | null => {
    let temp = state?.approvalRequest?.approvalRequest?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.approvalRequest?.approvalRequest[0] || null
  }
export const get_selected_approvalRequest = (state: {
  approvalRequest: approvalRequestSliceState
}): ApprovalRequest | null => {
  let id = state?.approvalRequest?.selected_approvalRequest
  let temp = state?.approvalRequest?.approvalRequest?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_approvalRequest = (state: {
  approvalRequest: {
    approvalRequest: ApprovalRequest[]
  }
}): ApprovalRequest[] => {
  let temp = state?.approvalRequest?.approvalRequest
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_approvalRequest_busy = (state: {
  approvalRequest: approvalRequestSliceState
}) => {
  return (
    state?.approvalRequest.is_deleting_approvalRequest ||
    state?.approvalRequest.is_loading_approvalRequest ||
    state?.approvalRequest.is_creating_approvalRequest
  )
}
export const is_deleting_approvalRequest_busy = (state: {
  approvalRequest: approvalRequestSliceState
}) => {
  return state?.approvalRequest.is_deleting_approvalRequest
}
export const is_loading_approvalRequest_busy = (state: {
  approvalRequest: approvalRequestSliceState
}) => {
  return state?.approvalRequest.is_loading_approvalRequest
}
export const is_creating_approvalRequest_busy = (state: {
  approvalRequest: approvalRequestSliceState
}) => {
  return state?.approvalRequest.is_creating_approvalRequest
}

export default approvalRequestSlice.reducer
